import { ItemVM } from 'shell/view-models/item';

export enum STATES_ACT {
  ID_STATE_BOZZA = '1',
  ID_STATE_BOZZA_EMERGENZA = '1E',
  ID_STATE_CONFERMATO = '2',
  ID_STATE_ANNULLATO = '3',
  ID_STATE_FIRMA_DICHIARANTE = '4',
  ID_STATE_FIRMA_COMPLETA_USC = '5',
  ID_STATE_FIRMA_COMPLETA_USC_EMERGENZA = '5E',
  ID_STATE_GENERATO_DA_SISTEMA = '6',
  ID_STATE_APPROVATO = '7',
  ID_STATE_RIFIUTATA = '8',
  ID_STATE_CANCELLATO = '9',
  ID_STATE_INEFFICACE = '10',
  ID_STATE_FIRMA_PER_CONFORMITA = '11',
  ID_STATE_MODIFICA_CON_ANNOTAZIONE = 'M',
}

export const LIST_STATES: Array<ItemVM> = [
  {
    id: STATES_ACT.ID_STATE_BOZZA,
    value: 'Bozza',
  },
  {
    id: STATES_ACT.ID_STATE_BOZZA_EMERGENZA,
    value: 'Bozza registro emergenza',
  },
  {
    id: STATES_ACT.ID_STATE_CONFERMATO,
    value: 'Confermato',
  },
  {
    id: STATES_ACT.ID_STATE_ANNULLATO,
    value: 'Annullato',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_DICHIARANTE,
    value: 'Firmato dal dichiarante',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_PER_CONFORMITA,
    value: 'Firma per conformità',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_COMPLETA_USC,
    value: 'Firma completa USC',
  },
];

export const LIST_STATES_COMPLETE: Array<ItemVM> = [
  {
    id: STATES_ACT.ID_STATE_BOZZA,
    value: 'Bozza',
  },
  {
    id: STATES_ACT.ID_STATE_BOZZA_EMERGENZA,
    value: 'Bozza registro emergenza',
  },
  {
    id: STATES_ACT.ID_STATE_CONFERMATO,
    value: 'Confermato',
  },
  {
    id: STATES_ACT.ID_STATE_ANNULLATO,
    value: 'Annullato',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_DICHIARANTE,
    value: 'Firmato dal dichiarante',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_COMPLETA_USC,
    value: 'Firma completa USC',
  },
  {
    id: STATES_ACT.ID_STATE_GENERATO_DA_SISTEMA,
    value: 'Generato da sistema',
  },
  {
    id: STATES_ACT.ID_STATE_APPROVATO,
    value: 'Approvato',
  },
  {
    id: STATES_ACT.ID_STATE_RIFIUTATA,
    value: 'Rifiutata',
  },
  {
    id: STATES_ACT.ID_STATE_CANCELLATO,
    value: 'Cancellato',
  },
  {
    id: STATES_ACT.ID_STATE_INEFFICACE,
    value: 'Inefficace',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_PER_CONFORMITA,
    value: 'Firma per conformità',
  },
];

export const LIST_STATES_WITH_ANNOTATION: Array<ItemVM> = [
  {
    id: STATES_ACT.ID_STATE_BOZZA,
    value: 'Bozza',
  },
  {
    id: STATES_ACT.ID_STATE_BOZZA_EMERGENZA,
    value: 'Bozza registro emergenza',
  },
  {
    id: STATES_ACT.ID_STATE_CONFERMATO,
    value: 'Confermato',
  },
  {
    id: STATES_ACT.ID_STATE_ANNULLATO,
    value: 'Annullato',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_DICHIARANTE,
    value: 'Firmato dal dichiarante',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_PER_CONFORMITA,
    value: 'Firma per conformità',
  },
  {
    id: STATES_ACT.ID_STATE_FIRMA_COMPLETA_USC,
    value: 'Firma completa USC',
  },
  {
    id: STATES_ACT.ID_STATE_MODIFICA_CON_ANNOTAZIONE,
    value: 'In corso di modifica con annotazione',
  },
];

export const getValueList = (id?: string): string => {
  const findItem: ItemVM | undefined =
    LIST_STATES_COMPLETE.find((item) => item.id === id) ||
    LIST_STATES_WITH_ANNOTATION.find((item) => item.id === id);

  return findItem?.value || '';
};
